module.exports = "/dist/assets/images/big-arrow-down.svg";